<template>
  <div class="card">
    <div class="card-head">
      <div style="width:88%;display: flex">
        <div class="start-label" />
        <span class="text">{{ title }}</span>
      </div>
      <!-- <div style="width:20%"> -->
      <img src="@/assets/icons/plus-blue.png" v-if="tableAcl.indexOf('Add') != -1" alt="" class="addbtn"
        v-preventReClick @click="handleAdd" />
      <!-- </div> -->
    </div>
    <div class="card-body">
      <el-input type="text" v-model="keyWord" suffix-icon="el-icon-search" style="height:32px; width: 240px;"
        @change="search" />
      <div style="margin:10px 0px">
        <template v-for="item in dataList">
          <div class="card-list card-data" :class="{ active: item.id == activeCard }" :key="item.id" v-preventReClick
            style="display: flex" @click="cardClick(item.id)">
            <div v-if="isShowNo" slot="reference" class="card-value" style="width: 160px;">
              <ShowTooltips :txt-info="(item.no ? item.no + ' ' : '') + (item.name ? item.name : '')
                ">
              </ShowTooltips>
            </div>
            <div v-else slot="reference" class="card-value" style="width: 160px;">
              <ShowTooltips :txt-info="(item.abbreviation ? item.abbreviation + ' ' : '') +
                (item.name ? item.name : '')
                ">
              </ShowTooltips>
            </div>

            <template v-if="item.id == activeCard">
              <i v-if="!isLast" class="el-icon-caret-right card-icon" />
              <i class="el-icon-delete card-icon opacity5" v-if="tableAcl.indexOf('Remove') != -1" v-preventReClick
                @click="handleDelete(item)" />
              <i class="el-icon-edit-outline card-icon opacity5" v-if="tableAcl.indexOf('Edit') != -1" v-preventReClick
                @click="handleUpdate(item)" />
            </template>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ShowTooltips from "@/components/show-tooltips";
export default {
  components: { ShowTooltips },
  name: "card",
  data () {
    return {
      activeCard: null,
      keyWord: "",
    };
  },
  props: {
    title: {
      type: String,
      default () {
        return "";
      },
    },
    dataList: {
      type: Array,
      default () {
        return [];
      },
    },
    type: {
      type: Number,
      default () {
        return 0;
      },
    },
    isLast: {
      type: Boolean,
      default () {
        return false;
      },
    },
    isShowNo: {
      type: Boolean,
      default () {
        return false;
      },
    },
    tableAcl: {
      type: Array,
      default () {
        return [];
      },
    },
  },
  methods: {
    cardClick (id) {
      this.activeCard = id;
      this.$emit("getChildrenData", id, this.type);
    },
    search (val) {
      this.$emit("filterMethod", val, this.type);
    },
    handleAdd () {
      this.$emit("handleAdd", this.type);
    },
    handleDelete (row) {
      this.$emit("handleDelete", row);
    },
    handleUpdate (row) {
      this.$emit("handleUpdate", row);
    },
  },
};
</script>
